import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Search, Info, Calendar, FileText, Euro } from "lucide-react";
import { PageHero, Section, Card } from "@/components/Section";
import { IMAGES } from "@/lib/site";

// Tarifs annuels 2026/2027 (€) - source : grille officielle du lycée
// Colonnes : Externe / Demi-pension 3J / Demi-pension 4J / Demi-pension 5J / Interne
const TARIFS = [
  ["Dispositifs", [
    ["ULIS", 1019.9, 1611.2, 1779.1, 1954.3, 4804.3],
    ["UPE2A", 1019.9, 1655.0, 1837.5, 2027.3, 4877.3],
    ["3ème Prépa-Métiers", 1019.9, 1698.8, 1895.9, 2100.3, 4950.3],
  ]],
  ["CAP", [
    ["CAP C4A — Conducteur Agent d'Accueil en Autobus et Autocar", 1619.9, 2298.8, 2466.7, 2663.8, 5513.8],
    ["CAP AAGA 1 — Agent Accompagnant au Grand Âge", 1019.9, 1633.1, 1808.3, 1990.8, 4840.8],
    ["CAP AAGA 2 — Agent Accompagnant au Grand Âge", 1019.9, 1611.2, 1779.1, 1954.3, 4804.3],
    ["CAP EPC 1 — Équipier Polyvalent du Commerce", 1019.9, 1633.1, 1808.3, 1990.8, 4840.8],
    ["CAP EPC 2 — Équipier Polyvalent du Commerce", 1019.9, 1611.2, 1779.1, 1954.3, 4804.3],
    ["CAP IMTB 1 — Interventions en Maintenance Technique des Bâtiments", 1219.9, 1833.1, 2008.3, 2190.8, 5040.8],
    ["CAP IMTB 2 — Interventions en Maintenance Technique des Bâtiments", 1219.9, 1811.2, 1979.1, 2154.3, 5004.3],
    ["CAP MMV 1 — Métiers de la Mode Vêtement Flou", 1319.9, 1933.1, 2108.3, 2290.8, 5140.8],
    ["CAP MMV 2 — Métiers de la Mode Vêtement Flou", 1219.9, 1833.1, 2008.3, 2190.8, 5040.8],
    ["CAP OL 1 — Opérateur·trice de Logistique", 1019.9, 1633.1, 1808.3, 1990.8, 4840.8],
    ["CAP OL 2 — Opérateur·trice de Logistique", 1019.9, 1589.3, 1749.9, 1917.8, 4767.8],
    ["CAP PSR 1 — Production et Service en Restauration", 1019.9, 1633.1, 1808.3, 1990.8, 4840.8],
    ["CAP PSR 2 — Production et Service en Restauration", 1019.9, 1611.2, 1779.1, 1954.3, 4804.3],
  ]],
  ["Bac Pro AEPA — Animation Enfance & Personnes Âgées *", [
    ["2nde Bac Pro AEPA", 1269.9, 1883.1, 2058.3, 2240.8, 5090.8],
    ["1ère Bac Pro AEPA", 1269.9, 1861.2, 2029.1, 2204.3, 5054.3],
    ["Tle Bac Pro AEPA", 1269.9, 1905.0, 2087.5, 2277.3, 5127.3],
  ]],
  ["Bac Pro AGORA — Assistance Gestion Organisations & Activités", [
    ["2nde Bac Pro AGORA", 1019.9, 1655.0, 1837.5, 2027.3, 4877.3],
    ["1ère Bac Pro AGORA", 1019.9, 1611.2, 1779.1, 1954.3, 4804.3],
    ["Tle Bac Pro AGORA", 1019.9, 1655.0, 1837.5, 2027.3, 4877.3],
  ]],
  ["Bac Pro ASSP — Accompagnement Soins et Services à la Personne", [
    ["2nde Bac Pro ASSP", 1019.9, 1633.1, 1808.3, 1990.8, 4840.8],
    ["1ère Bac Pro ASSP", 1019.9, 1611.2, 1779.1, 1954.3, 4804.3],
    ["Tle Bac Pro ASSP", 1019.9, 1655.0, 1837.5, 2027.3, 4877.3],
  ]],
  ["Bac Pro CRM / CTRM — Conducteur Transport Routier Marchandises", [
    ["2nde Bac Pro CRM", 1619.9, 2298.8, 2495.9, 2700.3, 5550.3],
    ["1ère Bac Pro CTRM", 1619.9, 2320.7, 2525.1, 2736.8, 5586.8],
    ["Tle Bac Pro CTRM", 1619.9, 2320.7, 2525.1, 2736.8, 5586.8],
  ]],
  ["Bac Pro Métiers de l'Accueil & du Commerce", [
    ["2nde Bac Pro MRCA — Métiers Relation Clients Accueil", 1019.9, 1655.0, 1837.5, 2027.3, 4877.3],
    ["1ère Bac Pro MA — Métiers de l'Accueil", 1019.9, 1611.2, 1779.1, 1954.3, 4804.3],
    ["Tle Bac Pro MA — Métiers de l'Accueil", 1019.9, 1655.0, 1837.5, 2027.3, 4877.3],
    ["2nde Bac Pro MRCC — Métiers Relation Clients Commerce", 1019.9, 1655.0, 1837.5, 2027.3, 4877.3],
    ["1ère Bac Pro MCV — Métiers du Commerce et de la Vente", 1019.9, 1611.2, 1779.1, 1954.3, 4804.3],
    ["Tle Bac Pro MCV — Métiers du Commerce et de la Vente", 1019.9, 1655.0, 1837.5, 2027.3, 4877.3],
  ]],
  ["Bac Pro MLT — Logistique et Transport", [
    ["2nde Bac Pro MLT", 1019.9, 1633.1, 1808.3, 1990.8, 4840.8],
    ["1ère Bac Pro MLT", 1019.9, 1611.2, 1779.1, 1954.3, 4804.3],
    ["Tle Bac Pro MLT", 1019.9, 1655.0, 1837.5, 2027.3, 4877.3],
  ]],
  ["Bac Pro TAO — Technicien Appareillage Orthopédique", [
    ["2nde Bac Pro TAO", 1819.9, 2455.0, 2637.5, 2827.3, 5677.3],
    ["1ère Bac Pro TAO", 1419.9, 2011.2, 2179.1, 2354.3, 5204.3],
    ["Tle Bac Pro TAO", 1419.9, 2055.0, 2237.5, 2427.3, 5277.3],
  ]],
  ["Bac Pro Bâtiment (MEMNB & TEB)", [
    ["2nde Bac Pro MEMNB — Études et Modélisation Numérique du Bâtiment", 1019.9, 1655.0, 1837.5, 2027.3, 4877.3],
    ["1ère Bac Pro TEB — Technicien de Bâtiment", 1019.9, 1611.2, 1779.1, 1954.3, 4804.3],
    ["Tle Bac Pro TEB — Technicien de Bâtiment", 1019.9, 1655.0, 1837.5, 2027.3, 4877.3],
  ]],
  ["Classes Coiffure & Esthétique", [
    ["CAP Coiffure — 1ère année", 3019.9, 3633.1, 3808.3, 3990.8, 6840.8],
    ["CAP Coiffure — 2ème année", 2369.9, 2983.1, 3158.3, 3340.8, 6190.8],
    ["2de Bac Pro ECP — Esthétique Cosmétique Parfumerie", 2869.9, 3505.0, 3687.5, 3877.3, 6727.3],
    ["1ère Bac Pro ECP — Esthétique Cosmétique Parfumerie", 2669.9, 3261.2, 3429.1, 3604.3, 6454.3],
    ["Tle Bac Pro ECP — Esthétique Cosmétique Parfumerie", 2669.9, 3305.0, 3487.5, 3677.3, 6527.3],
  ]],
];

const COLS = ["Externe", "Demi-pension 3 J", "Demi-pension 4 J", "Demi-pension 5 J", "Interne"];

const fmt = (v) =>
  v.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";

export default function InfosPratiques() {
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    if (!query.trim()) return TARIFS;
    const q = query.toLowerCase();
    return TARIFS.map(([groupe, lignes]) => [
      groupe,
      lignes.filter((l) => l[0].toLowerCase().includes(q) || groupe.toLowerCase().includes(q)),
    ]).filter(([, lignes]) => lignes.length > 0);
  }, [query]);

  return (
    <div data-testid="infos-pratiques-page">
      <PageHero
        eyebrow="Infos pratiques · Tarifs 2026/2027"
        title="Frais de scolarité par classe et par formation"
        subtitle="Ces tarifs annuels tiennent compte des périodes de stage en entreprise, journées pédagogiques, ponts, examens et de la date de fin des cours théoriques. Ils sont indiqués pour chaque formule (externe, demi-pension, interne)."
        image={IMAGES.abstract}
      />

      <Section eyebrow="Grille tarifaire officielle" title="Tarifs annuels par classe">
        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="relative w-full sm:max-w-sm">
            <Search className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <input
              type="text"
              placeholder="Rechercher une classe (ex : CAP, AEPA, ECP…)"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              data-testid="tarifs-search"
              className="w-full rounded-full border border-border bg-brand-cream py-3 pl-11 pr-4 text-sm outline-none transition-all focus:border-brand-slate focus:ring-2 focus:ring-brand-sage/40"
            />
          </div>
          <p className="text-xs text-muted-foreground">
            * Pour les Bac Pro AEPA : voyage inclus, réparti sur 3 ans.
          </p>
        </div>

        <div className="overflow-hidden rounded-3xl border border-black/5 bg-brand-cream shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[820px] border-collapse text-sm" data-testid="tarifs-table">
              <thead>
                <tr className="bg-brand-slate-dark text-brand-cream">
                  <th className="px-4 py-4 text-left font-heading font-semibold">Classe / Formation</th>
                  {COLS.map((c) => (
                    <th key={c} className="px-4 py-4 text-right font-heading font-semibold">{c}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(([groupe, lignes]) => (
                  <React.Fragment key={groupe}>
                    <tr className="bg-brand-sand-wrapper">
                      <td colSpan={6} className="px-4 py-3 font-heading text-sm font-semibold uppercase tracking-wider text-brand-slate-dark">
                        {groupe}
                      </td>
                    </tr>
                    {lignes.map((l, idx) => (
                      <tr
                        key={`${groupe}-${idx}`}
                        className="border-t border-black/5 transition-colors hover:bg-brand-sand-wrapper/30"
                      >
                        <td className="px-4 py-3 text-brand-slate-dark">{l[0]}</td>
                        {[1, 2, 3, 4, 5].map((i) => (
                          <td key={i} className="px-4 py-3 text-right font-medium tabular-nums text-muted-foreground">
                            {fmt(l[i])}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
                {filtered.length === 0 && (
                  <tr>
                    <td colSpan={6} className="px-4 py-8 text-center text-muted-foreground">
                      Aucune classe ne correspond à votre recherche.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <p className="mt-6 text-xs text-muted-foreground">
          Les tarifs « Demi-pension » incluent la scolarité et les repas selon le nombre de jours
          (3, 4 ou 5 jours/semaine). Le tarif « Interne » comprend la scolarité, les repas 5 jours et
          l'hébergement. Possibilité de prélèvement automatique sur 9 mois (du 6 octobre au 6 juin).
        </p>
      </Section>

      <Section wrapper="bg-brand-sand-wrapper/40" eyebrow="Aides & facilités" title="Des solutions pour chaque famille">
        <div className="grid gap-6 md:grid-cols-3">
          <Card data-testid="aide-bourse">
            <Info className="h-7 w-7 text-brand-slate" />
            <h3 className="mt-5 font-heading text-lg font-bold text-brand-slate-dark">Bourses nationales</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              Le lycée est habilité à recevoir les boursiers de l'enseignement secondaire. Le
              secrétariat accompagne les familles dans les démarches.
            </p>
          </Card>
          <Card data-testid="aide-paiement">
            <Calendar className="h-7 w-7 text-brand-slate" />
            <h3 className="mt-5 font-heading text-lg font-bold text-brand-slate-dark">Prélèvement 9 mois</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              Échelonnement des frais sur 9 prélèvements automatiques du 6 octobre au 6 juin, sans
              frais supplémentaires.
            </p>
          </Card>
          <Card data-testid="aide-solidarite">
            <FileText className="h-7 w-7 text-brand-slate" />
            <h3 className="mt-5 font-heading text-lg font-bold text-brand-slate-dark">Fonds de solidarité</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              Un fonds interne permet d'accompagner les familles en difficulté ponctuelle. À évoquer
              en toute confidentialité avec la cheffe d'établissement.
            </p>
          </Card>
        </div>
      </Section>

      <Section wrapper="bg-brand-slate text-brand-cream">
        <div className="grid items-center gap-8 lg:grid-cols-[1.4fr_1fr]">
          <div>
            <Euro className="h-8 w-8 text-brand-sand" />
            <h2 className="mt-4 font-heading text-3xl font-bold sm:text-4xl">
              Une question sur les tarifs ou les aides ?
            </h2>
            <p className="mt-4 max-w-xl text-brand-cream/85">
              Notre secrétariat vous accompagne pas à pas, en toute confidentialité.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 lg:justify-end">
            <Link
              to="/contact"
              data-testid="infos-cta-contact"
              className="inline-flex items-center gap-2 rounded-full bg-brand-sand-dark px-6 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-sand"
            >
              Nous contacter
            </Link>
            <Link
              to="/telechargements"
              data-testid="infos-cta-download"
              className="inline-flex items-center gap-2 rounded-full border border-brand-cream/30 px-6 py-3.5 text-sm font-semibold text-brand-cream transition-all duration-300 hover:bg-brand-cream hover:text-brand-slate-dark"
            >
              Télécharger la grille PDF
            </Link>
          </div>
        </div>
      </Section>
    </div>
  );
}
